import Vue from 'vue'
export default new Vue()
/**
 * 使用方式：
 * 在需要通信的两个组件上
 * import Bus from '@/bus.js'
 *
 * 发送方：Bus.$emit('自定义事件名',data)
 * 接收方：Bus.$on('自定义事件名',data => {})
 * * */
